// store/index.ts
import { createStore } from 'vuex';

// Define los tipos para Usuario y Rol
export interface Rol {
  idRol: string;
  rol: string;
  permisos: [Permiso];
}
// Define los tipos para Usuario y Rol
export interface Permiso {
  idPermiso: string;
  permiso: string;
  categoria: string;
  subCategoria: string;
}

export interface Usuario {
  idPersona: string;
  nroColegium: number | null;
  fotoUrl: string | null;
  apellido: string;
  nombre: string;
  dniPass: string;
  genero: string;
  fechaNac: string | null;
  cargo: string | null;
  Contraseña: string | null;
  ContraseñaSinHash: string | null;
  fechaIngreso: string | null;
  idiomaPreferido: string | null;
  idEstadonavigation: {
    idEstado: string;
    tipoEstado: string;
  } | null;
  personasRoles: Array<{
    idPersona: string;
    idRol: string;
    fechaHora: string;
    idRolNavigation: Rol;
  }> | null;
  personasPermisos: Array<{
    idPersona: string;
    idPermiso: string;
    fechaHora: string;
    idPermisoNavigation: Permiso;
  }> | null;
  email: Array<{
    idPersona: string;
    idEmail: string;
    email: string;
  }> | null;
}

interface ConnectedUser {
  connectionId: string;
  userId: string;
  username: string;
  userPhotoUrl?: string;
  nivelSector?: string;
  connectedAt: Date;
}

// Define el store
const store = createStore({
  state: {
    authenticated: !!localStorage.getItem('authToken'),
    user: JSON.parse(localStorage.getItem('user') || 'null') as Usuario | null,
    theme: localStorage.getItem('Tema') || 'claro',
    connectedUsers: [] as ConnectedUser[]
  },
  mutations: {
    SET_AUTH: (state, auth: boolean) => state.authenticated = auth,
    SET_USER: (state, user: Usuario | null) => state.user = user,
    SET_THEME: (state, theme: string) => {
      state.theme = theme;
    },
    SET_CONNECTED_USERS(state, users /*: ConnectedUser[] */) {
      state.connectedUsers = users;
    },
    // Mutación para añadir/actualizar un usuario conectado
    ADD_OR_UPDATE_CONNECTED_USER(state, user /*: ConnectedUser */) {
      const index = state.connectedUsers.findIndex(u => u.userId === user.userId);
      if (index !== -1) {
        // Si el usuario ya existe (por su userId), lo actualizamos
        state.connectedUsers.splice(index, 1, user);
      } else {
        // Si es un usuario nuevo, lo añadimos
        state.connectedUsers.push(user);
      }
    },
    // Mutación para eliminar un usuario conectado
    REMOVE_CONNECTED_USER(state, userId /*: string */) {
      state.connectedUsers = state.connectedUsers.filter(u => u.userId !== userId);
    }
  },
  actions: {
    setAuth: ({ commit }, auth: boolean) => commit('SET_AUTH', auth),
    setUser: ({ commit }, user: Usuario | null) => commit('SET_USER', user),
    setTheme: ({ commit }, theme: string) => commit('SET_THEME', theme),
    logOut({ commit }) {
      // Resetea el estado
      commit('SET_USER', null);
      commit('SET_AUTH', false);

      // Limpia el localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('authToken');
    },
    setConnectedUsers: ({ commit }, users /*: ConnectedUser[] */) => commit('SET_CONNECTED_USERS', users),
    addOrUpdateConnectedUser: ({ commit }, user /*: ConnectedUser */) => commit('ADD_OR_UPDATE_CONNECTED_USER', user),
    removeConnectedUser: ({ commit }, userId /*: string */) => commit('REMOVE_CONNECTED_USER', userId),
  },
  getters: {
    // Getter para obtener la lista de usuarios conectados
    getConnectedUsers: (state) => state.connectedUsers,
    // Puedes añadir otros getters si necesitas filtrar o procesar esta lista
  },
  modules: {}
});

export default store;
